import { Link } from 'react-router-dom'
import { Bell, Moon, Sun } from 'lucide-react'
import { useThemeStore } from '../stores/themeStore.js'
import { useInvitations } from '../hooks/useInvitations.js'

const TopBar = ({ title }) => {
  const { darkMode, toggleDarkMode } = useThemeStore()
  const { data: invitations } = useInvitations()
  const pendingCount = invitations?.length ?? 0

  return (
    <header className="h-16 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-950 flex items-center justify-between px-6 sticky top-0 z-30">
      <h1 className="text-xl font-bold text-gray-900 dark:text-white">{title}</h1>
      <div className="flex items-center gap-1">
        <Link
          to="/invitations"
          aria-label={pendingCount > 0 ? `Invitations, ${pendingCount} pending` : 'Invitations'}
          className="relative p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        >
          <Bell className="w-5 h-5 text-gray-500" />
          {pendingCount > 0 && (
            <span
              data-testid="invitations-badge"
              className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[11px] font-bold flex items-center justify-center"
            >
              {pendingCount}
            </span>
          )}
        </Link>
        <button
          onClick={toggleDarkMode}
          className="p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          aria-label="Toggle dark mode"
        >
          {darkMode ? (
            <Sun className="w-5 h-5 text-amber-500" />
          ) : (
            <Moon className="w-5 h-5 text-gray-500" />
          )}
        </button>
      </div>
    </header>
  )
}

export default TopBar
